module.exports = __webpack_public_path__ + "media/post-listing-hero@2x.937e108e.jpg";